<template>
  <div class="home">
    <Hero :title="heroTitle" :imageUrl="heroImage" />
    <section class="main-content">
      <div class="container">
        <h2>Welcome to China Stroll</h2>
        <p>
          Discover the beauty and culture of China through our curated content. Explore serene locations, immerse yourself in cultural experiences, and enjoy captivating stories.
        </p>
        <div class="home-sections">
          <div class="section">
            <router-link to="/explore">
              <img src="@/assets/images/explore-thumbnail.jpg" alt="Explore" />
              <h3>Explore</h3>
            </router-link>
          </div>
          <div class="section">
            <router-link to="/culture">
              <img src="@/assets/images/culture-thumbnail.jpg" alt="Culture" />
              <h3>Culture</h3>
            </router-link>
          </div>
          <div class="section">
            <router-link to="/stories">
              <img src="@/assets/images/stories-thumbnail.jpg" alt="Stories" />
              <h3>Stories</h3>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue';
import heroImage from '@/assets/images/home-hero.jpg';

export default {
  name: 'Home',
  components: {
    Hero,
  },
  data() {
    return {
      heroTitle: 'China Stroll',
      heroImage,
    };
  },
};
</script>

<style scoped>
.main-content {
  padding: 40px 0;
  text-align: center;
}

.main-content h2 {
  font-size: 2em;
  margin-bottom: 20px;
}

.main-content p {
  font-size: 1.2em;
  margin-bottom: 40px;
}

.home-sections {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.home-sections .section {
  flex: 1;
  margin: 0 15px;
  text-align: center;
}

.home-sections .section img {
  max-width: 100%;
  border-radius: 6px;
}

.home-sections .section h3 {
  margin-top: 15px;
  font-size: 1.5em;
  color: #333;
}

@media (max-width: 768px) {
  .home-sections {
    flex-direction: column;
  }
  .home-sections .section {
    margin: 15px 0;
  }
}
</style>